/* Copyright CloudLinux Zug GmbH 2010-2017 All Rights Reserved
 *
 * Licensed under CLOUD LINUX LICENSE AGREEMENT
 * http://cloudlinux.com/docs/LICENSE.TXT
 */

import { ConvertFormat } from './types';

export class Sorter{
    static numberRegex = /^[\d\.]+%?$/;
    direction: number;
    key: string;

    static parseNumber(value): number {
        return Sorter.numberRegex.test(value) ? parseFloat(value) : 0;
    }

    static getValue(property){
        if (property.hasOwnProperty('value')) {
            if (property.hasOwnProperty('rawValue')) {
                return property.rawValue;
            } else {
                return property.value;
            }
        }
        return property;
    }

    constructor(){
        this.direction = 1;
    }

    sort(key, data, changeDirection, convertToFormat: ConvertFormat = null) {
        if (convertToFormat === null) return;

        if (this.key === key && changeDirection){
            if (typeof changeDirection === 'number') {
                this.direction = changeDirection;
            } else {
                this.direction = this.direction * -1;
            }
        }
        else{
            this.direction = 1;
        }
        this.key = key;
        data.sort((a, b) => {
            let val1, val2;
            if (!(
                (a.hasOwnProperty(key) || !!a.__lookupGetter__(key)) &&
                (b.hasOwnProperty(key) || !!b.__lookupGetter__(key))
               ))
                return 0;
            val1 = Sorter.getValue((a[key] === null) ? '' : a[key]);
            val2 = Sorter.getValue((b[key] === null) ? '' : b[key]);
            switch (convertToFormat) {
                case 'string':
                    val1 = val1.toString();
                    val2 = val2.toString();
                    break;
                case 'byte-amount':
                case 'number':
                    val1 = Sorter.parseNumber(val1);
                    val2 = Sorter.parseNumber(val2);
                    break;
                default:
                    break;
            }
            return val1 === val2 ? 0 :
                (val1 > val2 ? this.direction : -1 * this.direction);
        });
    }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./node_modules/angular-router-loader/src?loader=system&genDir=compiled&aot=false!./src/app/utils/sorter.ts